module.exports = {"130732100":"赤城镇","130732101":"田家窑镇","130732102":"龙关镇","130732103":"雕鹗镇","130732104":"独石口镇","130732105":"白草镇","130732106":"龙门所镇","130732107":"后城镇","130732108":"东卯镇","130732200":"炮梁乡","130732201":"大海陀乡","130732202":"镇宁堡乡","130732203":"马营乡","130732204":"云州乡","130732205":"三道川乡","130732206":"东万口乡","130732207":"茨营子乡","130732208":"样田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130732.json
// module id = 282
// module chunks = 0